// ViewSwitcher — the three views (Q4), as a segmented control.
//
// Three separate views rather than one sort dropdown, because they answer
// three different questions and Miles asked for them by name: "everything,
// newest first" is the archive; "who's waiting" is the morning queue, WHP's
// own held items first and the longest wait at the top; "latest activity" is
// what moved while you were away.
//
// The chosen view is remembered per browser and mirrored into the URL, so a
// pasted link opens on the view the sender was looking at while a fresh visit
// opens on the one this operator last used.

import { VIEW_HINT, VIEW_LABEL, VIEWS } from '@/components/sentItems/sentItemsView';
import type { SentItemsView } from '@/lib/sentItemsClient';

export function ViewSwitcher({
  view,
  onChange,
}: {
  view: SentItemsView;
  onChange: (next: SentItemsView) => void;
}): React.JSX.Element {
  return (
    <div
      className="tabs si-views"
      data-variant="segmented"
      role="tablist"
      aria-label="How to look at what has been sent"
    >
      {VIEWS.map((v) => (
        <button
          key={v}
          type="button"
          className="tab"
          role="tab"
          aria-selected={v === view}
          onClick={() => onChange(v)}
        >
          {VIEW_LABEL[v]}
          <span className="si-view-hint">{VIEW_HINT[v]}</span>
        </button>
      ))}
    </div>
  );
}
